import dayjs from "dayjs"
import {
  useEffect,
  useState,
  useCallback,
} from "react"
import { useInterval } from "usehooks-ts"
import { usePageLifecycleContext } from "src/contexts"
import { PageLifecycle } from "src/types"

interface State {
  time: string;
  timeUntilNextUpdate: number;
}

function getTimeState(): State {
  return {
    time: dayjs().startOf("day")
      .toISOString(),
    timeUntilNextUpdate: dayjs()
      .add(
        1,
        "day",
      )
      .startOf("day")
      .diff(
        dayjs(),
        "millisecond",
      ),
  }
}

// returns the starting time of today
export function useToday(): string {
  const pageLifecycle = usePageLifecycleContext()

  const [
    timeState,
    setTimeState,
  ] = useState<State>(getTimeState())

  const updateState = useCallback(
    () => {
      setTimeState(getTimeState())
    },
    [setTimeState],
  )

  // when the page becomes unhidden, update the state
  useEffect(
    () => {
      if (
        pageLifecycle === PageLifecycle.Active ||
        pageLifecycle === PageLifecycle.Passive
      ) {
        updateState()
      }
    },
    [
      updateState,
      pageLifecycle,
    ],
  )

  // note that browsers will not execute this when the page is hidden
  useInterval(
    updateState,
    timeState.timeUntilNextUpdate,
  )

  return timeState.time
}
